export const AGENT_OTP_LENGTH = 6;

/**
 * Strip non-digits and clamp to the OTP field length.
 */
export function parseOtpDigits(raw: string, length: number = AGENT_OTP_LENGTH): string {
  return raw.replace(/\D/g, '').slice(0, length);
}

/**
 * Merge a single typed digit into an existing OTP string at the given index.
 */
export function mergeOtpDigit(
  existing: string,
  index: number,
  raw: string,
  length: number = AGENT_OTP_LENGTH,
): string {
  const digits = parseOtpDigits(raw, length);
  if (digits.length > 1) {
    return digits;
  }
  const chars = Array.from({ length }, (_, charIndex) => existing[charIndex] ?? '');
  chars[index] = digits.slice(-1);
  return chars.join('').slice(0, length);
}

/**
 * Index of the OTP box that should receive focus after digits are applied.
 */
export function getOtpFocusIndex(code: string, length: number = AGENT_OTP_LENGTH): number {
  if (!code) {
    return 0;
  }
  return Math.min(Math.max(code.length, 1) - 1, length - 1);
}
